module.exports = __webpack_public_path__ + "img/202308031200030222i0.35db369d.jpg";